<template>
  <BaseTable
      :title="$t('task_template_one')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="TaskTemplateOneListQueryDTO"
      dto-save-list-model="TaskTemplateOneSaveListCommandDTO"
      store-name="TaskTemplateOneTable"
      new-item-component="TaskTemplateOneItem"
      :parent-uid="parentUid"
      new-item-pass="/Product/TaskTemplateOne/TaskTemplateOneItem"
      :lang-dictionary="function(text) {return $t(text)}"
      hide-default-footer
      fixed-header
  >
    <template v-slot:item.name="{ item }">
      <router-link :to="{name:'TaskTemplateOneItem', params: { parentUid: parentUid, itemUid: item.uid}}">
        <span v-if="item.name">{{ item.name }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";

export default {
  name: 'TskTemplateOneTable',
  props: {
    subtractHeight: {type: [Number], default: 280},
    height: {type: [Number], default: window.innerHeight},
    parentUid: {default: null},
  },

  components: {
    BaseTable,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n src=".\locales.json">
</i18n>
